import { Toast, useToastState, type ToastProps } from '@tamagui/toast'
import { Circle, Text, useThemeName, View } from 'tamagui'
export interface CustomToastProps extends ToastProps {
  isExpo?: boolean
}
export function CustomToast({ isExpo = false, ...props }: CustomToastProps) {
  const themeName = useThemeName()
  const currentToast = useToastState()

  if (!currentToast || currentToast.isHandledNatively || isExpo) {
    return null
  }

  return (
    <Toast
      {...props}
      key={currentToast.id}
      duration={currentToast.duration}
      viewportName={currentToast.viewportName}
      theme={currentToast.theme ?? themeName}
    >
      <View gap="$2">
        <View fd="row" jc="space-between" ai="center">
          <Toast.Title fos="$4" theme="alt1">
            {currentToast.codeError ? `[${currentToast.codeError}] - ` : ''}
            {currentToast.title}
          </Toast.Title>
          <Toast.Close>
            <Circle size="$1" theme="alt2" bc="$background">
              <Text fow="bold">X</Text>
            </Circle>
          </Toast.Close>
        </View>
        {!!currentToast.message && (
          <Toast.Description fos="$3" theme="alt2">
            {currentToast.message}
          </Toast.Description>
        )}
      </View>
    </Toast>
  )
}
